import { ReactElement } from 'react';
import { usePageViewAnalytics } from '@client/analytics/hooks';
import { TEALIUM_PAGE_TYPE } from '@client/analytics/types/types';
import { InactivityLogoutAlert } from '@client/common/components/InactivityLogoutPage/InactivityLogoutAlert';
import { StatusCodes } from 'http-status-codes';
import { Props } from './InactivityLogoutPage.types';

export const InactivityLogoutPage = (props: Props): ReactElement => {
  usePageViewAnalytics({
    pageType: TEALIUM_PAGE_TYPE.notAllowedPage,
    data: {
      server: {
        code: StatusCodes.UNAUTHORIZED,
      },
    },
  });

  return (
    <InactivityLogoutAlert {...props} />
  );
};
